import { Menu, MenuItem, MenuList } from '@mui/material'
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state'
import { Fragment } from 'react/jsx-runtime'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import SkipModal from './SkipModal'
import ResetModal from './ResetModal'
import { SIZING } from '@common/theme/sizing'
import { SPACING } from '@common/theme/spacing'

export default function PopupMenuList({
  read_task_id,
  read_pseudo_id,
  study_id,
}: {
  read_task_id: string
  read_pseudo_id: number
  study_id: string
}) {
  return (
    <PopupState variant="popover">
      {(popupState) => (
        <Fragment>
          <MoreVertRoundedIcon
            fontSize="small"
            {...bindTrigger(popupState)}
            onClick={(e) => {
              popupState.open(e)
              e.stopPropagation()
            }}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                borderRadius: '50%',
                backgroundColor: 'background.default',
              },
            }}
            data-testid="popup-menu-icon"
          />
          <Menu
            {...bindMenu(popupState)}
            onClick={(e) => e.stopPropagation()}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            data-testid="popup-menu-list"
          >
            <MenuList
              sx={{
                width: SIZING.menuListWidth,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                paddingY: SPACING.spacingSm,
                outline: 'none',
              }}
            >
              <MenuItem
                sx={{
                  width: '100%',
                }}
                data-testid="popup-menu-list-item-skip"
              >
                <SkipModal
                  read_task_id={read_task_id}
                  read_pseudo_id={read_pseudo_id}
                  study_id={study_id}
                  popupState={popupState}
                />
              </MenuItem>
              <MenuItem
                sx={{
                  width: '100%',
                }}
                data-testid="popup-menu-list-item-reset"
              >
                <ResetModal
                  read_task_id={read_task_id}
                  read_pseudo_id={read_pseudo_id}
                  study_id={study_id}
                  popupState={popupState}
                />
              </MenuItem>
            </MenuList>
          </Menu>
        </Fragment>
      )}
    </PopupState>
  )
}
